import { ChatBubbleLeftIcon } from "@heroicons/react/24/outline";
import { isPhoneNumberE164, toPhoneNumberE164 } from "@sp-crm/core";
import React from "react";
import { usePhoneLines } from "store/selectors/telecom";
import { SendSmsPanel } from "./send-sms-panel";

interface PhoneSmsButtonProps {
    value: string;
}

export const PhoneSmsButton: React.FC<PhoneSmsButtonProps> = props => {
    const { value } = props;

    const [isOpen, setIsOpen] = React.useState(false);

    const sendingPhoneNumbers = usePhoneLines();

    const handleSms = React.useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(true);
    }, []);

    const handleDismiss = React.useCallback(() => {
        setIsOpen(false);
    }, []);

    if (sendingPhoneNumbers.length === 0 || !isPhoneNumberE164(value)) {
        return null;
    }

    return (
        <>
            <div>
                <a href="#" onClick={handleSms}>
                    <ChatBubbleLeftIcon className="w-5 h-5" />
                </a>
            </div>
            <SendSmsPanel
                isOpen={isOpen}
                onDismiss={handleDismiss}
                recipient={toPhoneNumberE164(value)}
            />
        </>
    );
};
